<template>
  <div id="menu-container">
    <div class="logo-menu"></div>
    <div class="menu-list">
      <ul>
        <li v-for="(page,index) in links" :key="index" v-on:click="closeMenu">
          <router-link :to="'/'+page">
            {{$t('menu.' + page)}}
          </router-link>
        </li>
      </ul>
    </div>
    <div class="language-select-box">
      <language-selector />
    </div>
  </div>
</template>

<script>
import LanguageSelector from "./LanguageSelector";

export default {
    name: "menu-content",
    props: ['closeMenu'],
    components: {LanguageSelector},
    data(){
      return{
        links : ['kit', 'story', 'about'],
      }
    }
}
</script>

<style scoped>
#menu-container{
  min-height: 100vh;
  background: #fff;
  color: #505050;
  display: flex;
  flex-direction: column;
}

.logo-menu{
  width: 100%;
  min-height: 40px;
  background: url("../../static/logo/bedayda_logo_black_new_360.png") no-repeat left center;
  background-size: 106px 50px;
  margin-bottom: 30px;
  margin-top: 30px;
  margin-left: 40px;
}
.menu-list ul{
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}
.menu-list li{
  list-style: none;
  display: flex;
  align-items: center;
  height: 70px;
  width: 100%;
  border-top: 1px solid #63EAAD;
  font-size: 16px;
  font-weight: bold;
  text-transform: capitalize;
  text-align: left;
  padding-left: 40px
}

.menu-list li:last-child{
  border-bottom: 1px solid #63EAAD;
}

.menu-list a, .menu-list a:active{
  color: #505050;
  text-decoration: none;
  width: 100%;
}

.language-select-box{
  margin-top: auto;
  margin-bottom: 20px;
  justify-content: center;
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/MenuContent.vue